import { BodiedSyncBlockSharedCssClassName } from '@atlaskit/editor-common/sync-block';
import { findParentNodeOfType } from '@atlaskit/editor-prosemirror/utils';
import { Decoration, DecorationSet } from '@atlaskit/editor-prosemirror/view';
export var calculateDecorations = function calculateDecorations(doc, selection, schema) {
  var bodiedSyncBlock = schema.nodes.bodiedSyncBlock;
  var syncBlockParent = findParentNodeOfType(bodiedSyncBlock)(selection);
  if (syncBlockParent) {
    var node = syncBlockParent.node,
      pos = syncBlockParent.pos;
    var decoration = Decoration.node(pos, pos + node.nodeSize, {
      class: "".concat(BodiedSyncBlockSharedCssClassName.selectionInside)
    });
    return DecorationSet.create(doc, [decoration]);
  }
  return DecorationSet.empty;
};